import { useTranslation } from 'react-i18next';

const INSTRUCTIONS_URL = 'https://drive.google.com/file/d/1pVAtGzQVhQV8XR7JBswLayNTf9qTWTPC/view?usp=sharing';

export const DeliveryInstructionsLink = () => {
  const { t } = useTranslation();

  return (
    <div className="m-b-16 width-100 flex-center-center-row-nowrap">
      <a href={INSTRUCTIONS_URL} target="_blank" rel="noopener noreferrer" className="normalText4 text-blue link-reset">
        {t('DELIVERY.INSTRUCTIONS_LINK')}
      </a>
    </div>
  );
};
